module.exports = __webpack_public_path__ + "assets/hubspot-wordpress-plugin.b91d0d3e.svg";